import { createAsyncThunk } from '@reduxjs/toolkit';
import { _reportSettingsUrls } from '@custom/Utils/constants/apiUrls';
import { SubmitReportsSettingsPayload } from '@custom/Utils/constants/interfaces';

export const submitReportsSettingsForm = createAsyncThunk<
  any,
  SubmitReportsSettingsPayload
>(
  'submitReportsSettingsForm',
  async (obj, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_reportSettingsUrls.edit, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(obj),
      });

      const data = await response.json();

      if (response.ok) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
